import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import Tooltip from '../../../../../components/Tooltip';
import Switch from '../../../../../components/YesNoSwitch';

export const HandicapsSection = (props: IProps2) => {
  const { handicapMetricStatus, values, setValue, onChangeToggle } = props;

  const handicapMetric = [
    { value: '1', label: 'Current GHIN' },
    { value: '2', label: 'Lowest GHIN' },
    // { value: '3', label: 'Club Index or GHIN' },
    // { value: '4', label: 'Club Index' },
    { value: '5', label: 'Manual' }
  ];

  return (
    <Paper
      elevation={1}
      className={`paper paper-full handicap-accordion ${handicapMetricStatus ? 'open' : 'closed'}`}
    >
      <div className="title__container override">
        <h3 className="title-tooltip override">HANDICAPS</h3>
        <Tooltip
          classes={{ fab: 'tooltip-fab--shift-top-2dot5' }}
          sectionKey="EVENT_SETUP.HANDICAPS"
        />
      </div>
      <div className="admin-form-field">
        <div className="label-row-grey">
          <div>WILL THERE BE HANDICAPS FOR THIS EVENT?</div>
          <div className="toggle">
            <Switch
              checked={handicapMetricStatus}
              onChange={onChangeToggle('handicap', setValue('handicapMetric'))}
              color="primary"
            />
          </div>
        </div>
      </div>

      <div className="admin-form-field handicap-options">
        <div className="label-row-grey">
          <div>WHICH INDEX WILL BE USED?</div>
        </div>
        <div className="admin-form-radios admin-form-radios--left-margin">
          <RadioGroup
            name="handicapMetric"
            value={values.handicapMetric && values.handicapMetric.toString()}
            onChange={setValue('handicapMetric')}
            color="primary"
            row={true}
          >
            {handicapMetric.map((item, index) => (
              <FormControlLabel
                className="handicap-options-item"
                key={`handicap-label-${index}`}
                color="primary"
                value={item.value}
                control={<Radio color="primary" />}
                label={item.label}
              />
            ))}
          </RadioGroup>
        </div>
      </div>
    </Paper>
  );
};
interface IProps2 {
  handicapMetricStatus: boolean;
  onChangeToggle: (type: string, setValue: any) => (_: any, value: boolean) => Promise<void>;
  setValue: (field: string) => (event: any) => void;
  values: any;
}
